import { Injectable } from '@angular/core';
import AppColor from '../../../../assets/data/app-colors.json'
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';

@Injectable({
  providedIn: 'root'
})
export class ChangeThemeService {
  appColor: any = AppColor;
  constructor(private globalCfg: GlobalCfgFactory,
    private customLanding: CustomLandingFactory
  ) { }

  setAppColors(){
    let isLanding: Boolean = this.customLanding.isLanding();
    let skin: string = isLanding?'landing':this.globalCfg.skin;
    let colorPalette = this.appColor[skin];
    document.documentElement.style.setProperty('--Main-050', colorPalette['Main-050']);
    document.documentElement.style.setProperty('--Main-100', colorPalette['Main-100']);
    document.documentElement.style.setProperty('--Main-200', colorPalette['Main-200']);
    document.documentElement.style.setProperty('--Main-300', colorPalette['Main-300']);
    document.documentElement.style.setProperty('--Main-400', colorPalette['Main-400']);
    document.documentElement.style.setProperty('--Main-500', colorPalette['Main-500']);
    document.documentElement.style.setProperty('--Main-600', colorPalette['Main-600']);
    document.documentElement.style.setProperty('--Main-700', colorPalette['Main-700']);
    document.documentElement.style.setProperty('--Main-800', colorPalette['Main-800']);
    document.documentElement.style.setProperty('--Main-900', colorPalette['Main-900']);
    document.documentElement.style.setProperty('--Main-1000', colorPalette['Main-1000']);
    if(isLanding){
      let custom: any = this.customLanding.getCustom();
      if(custom?.color){
        document.documentElement.style.setProperty('--Highlight-200', custom.color);
      }
      if(custom?.secondaryColor){
        document.documentElement.style.setProperty('--Secondary-Landing-1000', custom.secondaryColor);
      }
    }else{
      document.documentElement.style.setProperty('--Highlight-050', colorPalette['Highlight-050']);
      document.documentElement.style.setProperty('--Highlight-100', colorPalette['Highlight-100']);
      document.documentElement.style.setProperty('--Highlight-200', colorPalette['Highlight-200']);
    }
  }
}
